"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react/jsx-props-no-spreading */
var react_1 = __importDefault(require("react"));
var antd_1 = require("antd");
var icons_1 = require("@ant-design/icons");
var AntDragger = antd_1.Upload.Dragger;
var DragAndDrop = function (props) {
    var error = props.error, uploadHint = props.uploadHint, uploadText = props.uploadText, restProps = __rest(props, ["error", "uploadHint", "uploadText"]);
    return (react_1.default.createElement(AntDragger, __assign({}, restProps),
        react_1.default.createElement("p", { className: "ant-upload-drag-icon" },
            react_1.default.createElement(icons_1.InboxOutlined, null)),
        react_1.default.createElement("p", { className: "ant-upload-text" }, uploadText),
        react_1.default.createElement("p", { className: "ant-upload-hint" }, uploadHint),
        error && react_1.default.createElement("span", { style: { color: "red", marginBottom: 8 } }, error)));
};
exports.default = react_1.default.memo(DragAndDrop);
DragAndDrop.defaultProps = {
    uploadText: "Click or drag file to this area to upload",
    uploadHint: "Support for a single or bulk upload. Strictly prohibited from uploading company data or other band files",
};
